var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-4",attrs:{"absolute":"","color":"#000033","dark":"","fixed":""}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v(" WillWayNow.com ")])])}
var staticRenderFns = []

export { render, staticRenderFns }